import { useRef } from 'react'
import { useProjectPlanSelectGridOptions } from './gridOptions'
import { BulkSheetView } from '../../../../../containers/BulkSheetView'
import {
  useProjectPlanSelectSnapshotData,
  useProjectPlanSelectTemplateData,
} from './hooks/useProjectPlanSelectData'

type ProjectPlanSelectProps = {
  snapshotUuid: string
  selectedUuids: string[]
  updateSelectedUuid: (uuid: string, selected: boolean) => void
}

type ProjectPlanTemplateSelectProps = {
  projectUuid: string
  selectedUuids: string[]
  updateSelectedUuid: (uuid: string, selected: boolean) => void
}

export const ProjectPlanSelect = ({
  snapshotUuid,
  selectedUuids,
  updateSelectedUuid,
}: ProjectPlanSelectProps) => {
  const gridOptions = useProjectPlanSelectGridOptions(updateSelectedUuid)
  const ref = useRef<HTMLDivElement>(null)
  const { rows } = useProjectPlanSelectSnapshotData(snapshotUuid, selectedUuids)
  return <BulkSheetView ref={ref} gridOptions={gridOptions} rowData={rows} />
}

export const ProjectPlanTemplateSelect = ({
  projectUuid,
  selectedUuids,
  updateSelectedUuid,
}: ProjectPlanTemplateSelectProps) => {
  const gridOptions = useProjectPlanSelectGridOptions(updateSelectedUuid)
  const ref = useRef<HTMLDivElement>(null)
  const { rows } = useProjectPlanSelectTemplateData(projectUuid, selectedUuids)
  return <BulkSheetView ref={ref} gridOptions={gridOptions} rowData={rows} />
}
